// TESSERAX — FEEL de la BASCULE (cœur pur, testé).
//
// La Bascule (tilt horizontal du puits — mécanique signature) se rend déjà via une
// timeline cinématique dans main.ts : anticipation → penche → maintien → SLAM →
// retour. Ce module décide UNIQUEMENT du TEMPO de ce beat, isolé ici pour être
// testable (main.ts est @ts-nocheck) et pour que le seuil « gros coup » soit explicite.
//
// Pur : aucune dépendance THREE / DOM / RNG / WebAudio. Le ralenti est purement
// visuel — les clears/score d'une Bascule sont calculés à t=0 dans main.ts, donc le
// déterminisme du défi du jour et le score restent intacts quel que soit le tempo.

// Charge utile minimale d'un résultat de Bascule (sous-ensemble du `res` de main.ts).
export interface BasculeResult { chain: number; rows: number; slabs: number; }

// Une Bascule de MAÎTRISE : elle déclenche une CASCADE (chain ≥ 2), efface un TRIPLE+
// de lignes d'un coup (rows ≥ 3) ou complète une GRILLE pleine (slabs ≥ 1). C'est le
// coup « hero » que le ralenti met en valeur — les Bascules anodines (1-2 lignes) ou
// de PRÉPARATION (aucun clear) n'y entrent pas et gardent leur tempo vif.
export function isBigBascule(res: BasculeResult): boolean {
  return res.chain >= 2 || res.rows >= 3 || res.slabs >= 1;
}

// Facteur de RALENTI cinématique (multiplie la durée du beat). Une Bascule de maîtrise
// passe en « bullet-time » : le glissé décélère dans le mur, marque un temps au pic, puis
// SLAM — on savoure la mécanique signature. Les autres Bascules restent à 1 (tempo vif →
// la lisibilité du jeu ne souffre pas d'un ralenti à chaque tilt). En mode CHRONOMÉTRÉ le
// temps est la ressource du joueur : le ralenti est DAMPÉ pour rester équitable.
export function basculeSlowMo(res: BasculeResult, timed: boolean): number {
  if (!isBigBascule(res)) return 1;
  return timed ? 1.25 : 1.7;
}
